var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAbsent = function SvgIconAbsent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84217 9.46571V15H6.17649e-05C-0.000150595 14.1278 0.190902 13.2671 0.558582 12.4839C0.926261 11.7006 1.46081 11.0157 2.12126 10.4815C2.78172 9.94724 3.55055 9.57795 4.36885 9.40189C5.18715 9.22583 6.0332 9.24766 6.84217 9.46571ZM5.47375 8.57143C3.20559 8.57143 1.36848 6.65357 1.36848 4.28571C1.36848 1.91786 3.20559 0 5.47375 0C7.7419 0 9.57901 1.91786 9.57901 4.28571C9.57901 6.65357 7.7419 8.57143 5.47375 8.57143ZM9.57901 11.4286H9.92111H10.2632H10.9474H13.0001V12.8571H10.9474H10.2632H9.92111H9.57901H7.52638V11.4286H9.57901Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAbsent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-absent.5b91eca2.svg";
export { ForwardRef as ReactComponent };